export default __webpack_public_path__ + "static/media/ios_share_black_24dp.32f1d748.svg";